import * as api from "../api";

export const getGoogleAnalyticsReportByCountry = (
  startDate,
  endDate,
  url
) => {
  const searchParams = new URLSearchParams();
  searchParams.append("start-date", startDate);
  searchParams.append("end-date", endDate);
  searchParams.append("url", url);
  return api.get(
    `/google-analytics/page-view-country?` +
      searchParams.toString(),
    null
  );
};
export const getGoogleAnalyticsRealTimeReport = () => {
  return api.get(`/google-analytics/realtime-report`);
} 
